<template>
  <div class="screen-bigscreen" :class="{ 'is-fullscreen': isFullscreen }">
    <div class="bg-grid"></div>
    <div class="bg-glow"></div>

    <div class="scale-wrap" :class="{ 'is-fullscreen': isFullscreen }">
      <div class="dashboard" ref="dashboard">
        <!-- ===== Header ===== -->
        <header class="header">
          <div class="header-left">
            <div class="header-logo">
              <img src="/img/qiche.png" alt="汽车科技集团" />
            </div>
            <div class="title-block">
              <div class="header-title">SRM采购管理驾驶舱</div>
              <div class="header-subtitle">SMART PROCUREMENT COCKPIT</div>
            </div>
          </div>
          <div class="header-center">采购执行监控中心</div>
          <div class="header-right">
            <div class="org-switcher">
              <span class="org-label">子公司：</span>
              <div class="org-dropdown">
                <select v-model="factoryCode" @change="onOrgSwitch" aria-label="子公司切换">
                  <option value="all">全部子公司</option>
                  <option v-for="f in factoryList" :key="f.orgCode" :value="f.orgCode">
                    {{ f.orgCode }} · {{ f.orgName }}
                  </option>
                </select>
                <svg class="caret" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/></svg>
              </div>
            </div>
            <button class="refresh-btn" :class="{ spinning: refreshing }" type="button" title="手动刷新" @click="onRefresh">
              <svg viewBox="0 0 24 24"><path d="M17.65 6.35A7.95 7.95 0 0 0 12 4a8 8 0 1 0 7.39 11h-2.08A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
              <span>刷新</span>
            </button>
            <button class="fullscreen-btn" type="button" title="全屏展示" @click="toggleFullscreen">
              <svg viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
              <span>全屏</span>
            </button>
            <button class="db-btn" type="button" title="查看统计指标SQL" @click="openSqlModal">
              <svg viewBox="0 0 24 24"><path d="M12 3C7 3 3 4.79 3 7v10c0 2.21 4 4 9 4s9-1.79 9-4V7c0-2.21-4-4-9-4zm0 2c4.08 0 7 1.39 7 2.5S16.08 10 12 10 5 8.61 5 7.5 7.92 5 12 5zm7 13.5c0 1.11-2.92 2.5-7 2.5s-7-1.39-7-2.5V9.83c1.62.99 4.32 1.67 7 1.67s5.38-.68 7-1.67v8.67zm0-9.5c0 1.11-2.92 2.5-7 2.5S5 10.11 5 9V8.33c1.62.99 4.32 1.67 7 1.67s5.38-.68 7-1.67V9z"/></svg>
              <span>数据源</span>
            </button>
          </div>
        </header>

        <!-- ===== Main ===== -->
        <div class="main">
          <!-- KPI Row -->
          <div class="kpi-row">
            <div class="kpi-card" v-for="(k, i) in kpis" :key="i">
              <div class="kpi-icon" :class="'k-' + (i + 1)">
                <svg viewBox="0 0 24 24"><path :d="k.icon"></path></svg>
              </div>
              <div class="kpi-info">
                <div class="kpi-name">{{ k.label }}</div>
                <div class="kpi-value-row">
                  <span class="kpi-value">{{ k.value }}</span>
                  <span class="kpi-unit">{{ k.unit }}</span>
                </div>
              </div>
              <div class="kpi-foot-note">{{ k.note }}</div>
            </div>
          </div>

          <!-- Row-2 -->
          <div class="row-2">
            <div class="card card-delay">
              <div class="card-header">
                <div class="card-title">延迟天数分布<span class="card-subtitle">（完成 vs 未完成）</span></div>
                <div class="card-actions"><span class="card-subtitle">单位：单</span></div>
              </div>
              <div class="card-body">
                <div class="delay-chart"><div ref="delayChart" class="delay-canvas"></div></div>
              </div>
            </div>

            <div class="card card-map">
              <div class="card-header">
                <div class="card-title">供应商区域分布<span class="card-subtitle">（按数量渐变）</span></div>
              </div>
              <div class="card-body" style="padding: 0;">
                <div class="map-wrap">
                  <div class="map-legend">
                    <span class="item">少</span>
                    <span class="gradient-bar"></span>
                    <span class="item">多</span>
                  </div>
                  <div ref="mapChart" class="map-canvas"></div>
                  <div class="map-tooltip-panel" :class="{ show: mapTooltip.show }" v-if="mapTooltip.show">
                    <div class="tt-header">{{ mapTooltip.name }}</div>
                    <div class="tt-row"><span>供应商总数：</span><span class="num" style="color:var(--text-primary)">{{ mapTooltip.total }}家</span></div>
                    <div class="tt-section-title">绩效等级分布：</div>
                    <div class="tt-row"><span style="color:#22c55e;font-weight:700">A级</span><span class="num" style="color:#22c55e">{{ mapTooltip.a }}家({{ pct(mapTooltip.a, mapTooltip.total) }}%)</span></div>
                    <div class="tt-row"><span style="color:#3b82f6;font-weight:700">B级</span><span class="num" style="color:#3b82f6">{{ mapTooltip.b }}家({{ pct(mapTooltip.b, mapTooltip.total) }}%)</span></div>
                    <div class="tt-row"><span style="color:#f59e0b;font-weight:700">C级</span><span class="num" style="color:#f59e0b">{{ mapTooltip.c }}家({{ pct(mapTooltip.c, mapTooltip.total) }}%)</span></div>
                    <div class="tt-row"><span style="color:#ef4444;font-weight:700">D级</span><span class="num" style="color:#ef4444">{{ mapTooltip.d }}家({{ pct(mapTooltip.d, mapTooltip.total) }}%)</span></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-2-right">
              <div class="card" style="flex: 1; min-height: 0;">
                <div class="card-header">
                  <div class="card-title">订单完成率</div>
                  <div class="card-actions">
                    <div class="year-filter" aria-label="年度筛选">
                      <span class="y-label">年度</span>
                      <el-select v-model="orderYear" multiple collapse-tags popper-class="screen-year-popper" @change="onOrderYearChange" placeholder="全部">
                        <el-option v-for="y in yearOptions" :key="y" :label="y" :value="y"></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="donut-wrap">
                    <div class="donut-chart">
                      <div ref="orderDonut" style="width:100%;height:100%"></div>
                      <div class="donut-center">
                        <div class="pct">{{ orderStatus.centerPct }}%</div>
                        <div class="lbl">订单完成率</div>
                      </div>
                    </div>
                    <div class="donut-legend">
                      <div class="item" v-for="(it, idx) in orderStatus.items" :key="idx">
                        <span class="swatch" :style="{ background: it.color }"></span>
                        <span>{{ it.name }}</span>
                        <span class="num">{{ it.value }}<span class="pct">({{ it.pct }}%)</span></span>
                      </div>
                    </div>
                  </div>
                  <div class="donut-footer">订单完成率 = (已关闭 + 已完成) 订单数 / 总订单数</div>
                </div>
              </div>

              <div class="card" style="flex: 1; min-height: 0;">
                <div class="card-header">
                  <div class="card-title">交货单执行情况统计</div>
                  <div class="card-actions">
                    <div class="year-filter" aria-label="年度筛选">
                      <span class="y-label">年度</span>
                      <el-select v-model="deliveryYear" multiple collapse-tags popper-class="screen-year-popper" @change="onDeliveryYearChange" placeholder="全部">
                        <el-option v-for="y in yearOptions" :key="y" :label="y" :value="y"></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="donut-wrap">
                    <div class="donut-chart">
                      <div ref="deliveryDonut" style="width:100%;height:100%"></div>
                      <div class="donut-center">
                        <div class="pct">{{ deliveryStatus.centerPct }}%</div>
                        <div class="lbl">交货单完成率</div>
                      </div>
                    </div>
                    <div class="donut-legend">
                      <div class="item" v-for="(it, idx) in deliveryStatus.items" :key="idx">
                        <span class="swatch" :style="{ background: it.color }"></span>
                        <span>{{ it.name }}</span>
                        <span class="num">{{ it.value }}<span class="pct">({{ it.pct }}%)</span></span>
                      </div>
                    </div>
                  </div>
                  <div class="donut-footer">交货单完成率 = 交货完成数 / 交货单总数</div>
                </div>
              </div>

              <div class="card" style="flex: 1; min-height: 0;">
                <div class="card-header">
                  <div class="card-title">交货完成率<span class="card-subtitle">（创建→收货）</span></div>
                  <div class="card-actions">
                    <div class="year-filter" aria-label="年度筛选">
                      <span class="y-label">年度</span>
                      <el-select v-model="deliveryRateYear" multiple collapse-tags popper-class="screen-year-popper" @change="onDeliveryRateYearChange" placeholder="全部">
                        <el-option v-for="y in yearOptions" :key="y" :label="y" :value="y"></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="donut-wrap">
                    <div class="donut-chart">
                      <div ref="deliveryRateDonut" style="width:100%;height:100%"></div>
                      <div class="donut-center">
                        <div class="pct">{{ deliveryRate.centerPct }}%</div>
                        <div class="lbl">7天内完成</div>
                      </div>
                    </div>
                    <div class="donut-legend">
                      <div class="item" v-for="(it, idx) in deliveryRate.items" :key="idx">
                        <span class="swatch" :style="{ background: it.color }"></span>
                        <span>{{ it.name }}</span>
                        <span class="num">{{ it.value }}<span class="pct">({{ it.pct }}%)</span></span>
                      </div>
                    </div>
                  </div>
                  <div class="donut-footer">交货完成率 = 7天内收货完成数 / 交货单总数</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Row-3 -->
          <div class="row-3">
            <div class="card">
              <div class="card-header">
                <div class="card-title">供应商月度绩效TOP10</div>
                <div class="card-actions">
                  <div class="year-filter" aria-label="月度筛选">
                    <span class="y-label">月度</span>
                    <el-select v-model="top10Month" size="mini" popper-class="screen-year-popper" @change="onTop10MonthChange">
                      <el-option v-for="m in top10MonthOptions" :key="m.value" :label="m.label" :value="m.value"></el-option>
                    </el-select>
                  </div>
                  <div class="top10-toggle">
                    <button class="top10-toggle-btn" :class="{ active: top10Mode === 'best', asc: top10Mode === 'best' }" type="button" @click="onTop10Toggle('best')">最佳</button>
                    <button class="top10-toggle-btn" :class="{ active: top10Mode === 'worst' }" type="button" @click="onTop10Toggle('worst')">较差</button>
                  </div>
                  <button class="detail-btn" type="button" title="跳转到供应商绩效查询页面" @click="goSupplierEva">
                    <svg viewBox="0 0 24 24"><path d="M14 3v2h3.59l-9.3 9.29 1.42 1.42L19 6.41V10h2V3h-7zM5 5v14h14v-7h-2v5H7V7h5V5H5z"/></svg>
                    查看绩效详情
                  </button>
                </div>
              </div>
              <div class="card-body" style="padding: 0;">
                <div class="data-table">
                  <div class="data-table-head top10-head">
                    <div>排名</div><div>供应商代码</div><div>工厂</div><div>品牌</div><div style="text-align:center">等级</div><div style="text-align:right">分数</div>
                  </div>
                  <div class="data-table-body top10-list">
                    <div class="data-row" :class="{ zebra: idx % 2 === 1 }" v-for="(r, idx) in top10Rows" :key="idx">
                      <div class="rank-cell"><span class="rank-medal">{{ idx + 1 }}</span></div>
                      <div class="supplier-code">{{ r.venderCode }}</div>
                      <div class="factory-cell">{{ r.factory }}</div>
                      <div class="brand-cell">{{ r.brand }}</div>
                      <div style="text-align:center"><span class="grade-cell" :class="'grade-' + (r.grade || 'd').toLowerCase()">{{ r.grade }}</span></div>
                      <div class="score-cell" style="text-align:right;font-family:var(--font-num)">{{ r.score }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <div class="card-title">采购组织下钻分析</div>
                <div class="card-actions">
                  <div class="year-filter" aria-label="年度筛选">
                    <span class="y-label">年度</span>
                    <el-select v-model="orgYear" multiple collapse-tags popper-class="screen-year-popper" @change="onOrgYearChange" placeholder="全部">
                      <el-option v-for="y in yearOptions" :key="y" :label="y" :value="y"></el-option>
                    </el-select>
                  </div>
                  <button class="export-btn" @click="onExportOrg">
                    <svg viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>
                    导出
                  </button>
                </div>
              </div>
              <div class="card-body" style="padding: 0;">
                <div class="data-table">
                  <div class="data-table-head org-table-head" style="padding-right: 18px;">
                    <div>子公司</div><div>采购组织</div><div style="text-align:right">任务总数</div><div style="text-align:right">进行中</div><div style="text-align:right; padding-right:12px">已办结</div><div style="padding-left:12px">办结率</div><div style="text-align:right">占比</div>
                  </div>
                  <div class="data-table-body">
                    <div class="data-row org-table-row" :class="[{ zebra: idx % 2 === 1 }, 'indent-' + o.level]" v-for="(o, idx) in flatOrgList" :key="o.id">
                      <div class="org-cell factory-col">
                        <span v-if="o.level === 0" class="org-caret" :class="{ 'is-leaf': !o.hasChildren, collapsed: o.hasChildren && !o.expanded }" @click="toggleOrgNode(o.id)">{{ o.hasChildren ? '▼' : '' }}</span>
                        <span v-if="o.level === 0" class="org-name">{{ o.name }}</span>
                      </div>
                      <div class="org-cell org-col">
                        <span v-if="o.level === 1" class="org-caret" :class="{ 'is-leaf': !o.hasChildren, collapsed: o.hasChildren && !o.expanded }" @click="toggleOrgNode(o.id)">{{ o.hasChildren ? '▼' : '' }}</span>
                        <span v-if="o.level >= 1" class="org-name">{{ o.name }}</span>
                      </div>
                      <div class="num" style="text-align:right">{{ fmt(o.total) }}</div>
                      <div class="num" style="text-align:right">{{ o.inProgress }}</div>
                      <div class="num" style="text-align:right; padding-right:12px">{{ o.completed }}</div>
                      <div style="display:flex; align-items:center; gap:8px; padding-left:12px;">
                        <div class="progress-track" style="flex:1"><div class="progress-fill" :style="{ width: orgBarWidth(o) + '%' }"></div></div>
                        <span class="num" style="min-width:42px; text-align:right">{{ Number(o.rate || 0).toFixed(1) }}%</span>
                      </div>
                      <div class="num" style="text-align:right; color:var(--text-muted)">{{ o.sharePct }}%</div>
                    </div>
                    <div v-if="flatOrgList.length === 0" class="data-row" style="grid-template-columns: 1fr; justify-content:center; color:var(--text-muted); padding:20px;">该组织暂无数据</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== Footer ===== -->
        <div class="footer">
          <span>数据来源：SRM采购管理驾驶舱</span>
          <span class="sep"></span>
          <span>数据更新时间：{{ updateTime }}</span>
        </div>
      </div>
    </div>

    <!-- ===== SQL 弹窗（数据源） ===== -->
    <div class="sql-modal" :class="{ show: sqlModalShow }">
      <div class="sql-modal-mask" @click="closeSqlModal"></div>
      <div class="sql-modal-panel">
        <div class="sql-modal-header">
          <div class="sql-modal-title">
            <svg viewBox="0 0 24 24" width="18" height="18" style="vertical-align:-3px;margin-right:6px"><path fill="#7dd3fc" d="M12 3C7 3 3 4.79 3 7v10c0 2.21 4 4 9 4s9-1.79 9-4V7c0-2.21-4-4-9-4zm0 2c4.08 0 7 1.39 7 2.5S16.08 10 12 10 5 8.61 5 7.5 7.92 5 12 5zm7 13.5c0 1.11-2.92 2.5-7 2.5s-7-1.39-7-2.5V9.83c1.62.99 4.32 1.67 7 1.67s5.38-.68 7-1.67v8.67zm0-9.5c0 1.11-2.92 2.5-7 2.5S5 10.11 5 9V8.33c1.62.99 4.32 1.67 7 1.67s5.38-.68 7-1.67V9z"/></svg>
            统计指标数据源（SQL）
          </div>
          <div class="sql-modal-meta">
            <span class="sql-counter">{{ currentSqlIdx + 1 }} / {{ SQL_DATABASE.length }}</span>
            <button class="sql-modal-close" type="button" aria-label="关闭SQL弹窗" title="关闭" @click="closeSqlModal">×</button>
          </div>
        </div>
        <div class="sql-modal-body">
          <div class="sql-list">
            <div class="sql-item" :class="{ active: i === currentSqlIdx }" v-for="(it, i) in SQL_DATABASE" :key="i" @click="currentSqlIdx = i">
              <span class="sql-item-num">{{ it.seq }}</span>
              <span class="sql-item-name">{{ it.name }}</span>
              <span class="sql-item-table" :title="it.table">{{ shortTable(it.table) }}</span>
            </div>
          </div>
          <div class="sql-detail">
            <div class="sql-detail-head">
              <div class="sql-detail-num">{{ currentSqlItem.seq }}</div>
              <div class="sql-detail-meta">
                <div class="sql-detail-name">{{ currentSqlItem.name }}</div>
                <div class="sql-detail-table">数据表：<code>{{ currentSqlItem.table }}</code></div>
              </div>
            </div>
            <div class="sql-detail-body">
              <div class="sql-detail-label">SQL 查询语句</div>
              <div class="sql-code-wrap">
                <div class="sql-code-toolbar">
                  <span class="sql-code-lang">SQL · {{ currentSqlItem.sql.length }} chars</span>
                  <button class="sql-copy-btn" :class="{ copied: sqlCopied }" type="button" title="复制 SQL" @click="handleCopySql">
                    <svg viewBox="0 0 24 24"><path :d="sqlCopied ? 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' : 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z'"></path></svg>
                    <span>{{ sqlCopied ? '已复制' : '复制 SQL' }}</span>
                  </button>
                </div>
                <pre class="sql-code"><code v-html="highlightedSql"></code></pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== 地图供应商详情面板 ===== -->
    <div class="map-detail-panel" :hidden="!mapDetail.show">
      <div class="map-detail-head">
        <span class="map-detail-province">{{ mapDetail.province || '—' }}</span>
        <button class="map-detail-close" type="button" aria-label="关闭供应商详情" @click="mapDetail.show = false">×</button>
      </div>
      <div class="map-detail-body">
        <div class="map-detail-row"><span class="map-detail-label">供应商总数</span><span class="map-detail-val">{{ mapDetail.total || '—' }}</span></div>
        <div class="map-detail-row"><span class="map-detail-label">A级（优秀）</span><span class="map-detail-val">{{ mapDetail.a || '—' }}</span></div>
        <div class="map-detail-row"><span class="map-detail-label">B级（良好）</span><span class="map-detail-val">{{ mapDetail.b || '—' }}</span></div>
        <div class="map-detail-row"><span class="map-detail-label">C级（一般）</span><span class="map-detail-val">{{ mapDetail.c || '—' }}</span></div>
        <div class="map-detail-row"><span class="map-detail-label">D级（需关注）</span><span class="map-detail-val">{{ mapDetail.d || '—' }}</span></div>
        <div class="map-detail-row"><span class="map-detail-label">平均绩效分</span><span class="map-detail-val">{{ mapDetail.avg || '—' }}</span></div>
      </div>
      <div class="map-detail-foot">数据源：su_supplier_basic（按 PROVINCE 聚合）</div>
    </div>
  </div>
</template>

<script>
import screenfull from 'screenfull'
import chinaJson from '@/assets/screen/china.json'
import { getKpi, getOrgDrill, exportDetail, getOrderStatus, getDeliveryStatus, getDeliveryRate, getSupplierMap, getSubCompanyList } from '@/controller/dashboard'
import { SQL_DATABASE } from './sqlDatabase'

const TEXT_PRIMARY = '#fff'
const TEXT_SECONDARY = 'rgba(255,255,255,0.7)'
const TEXT_MUTED = 'rgba(255,255,255,0.45)'

const baseTooltip = {
  backgroundColor: 'rgba(13,31,58,0.96)',
  borderColor: '#06b6d4',
  borderWidth: 1,
  textStyle: { color: TEXT_PRIMARY, fontSize: 13 },
  extraCssText: 'backdrop-filter: blur(8px); box-shadow: 0 4px 20px rgba(0,0,0,0.5);'
}

// KPI 图标 SVG path（与 index-annotated.html 一致）
const KPI_ICONS = [
  'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 9V3.5L18.5 9H13z',
  'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
  'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z',
  'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z'
]

let mapRegistered = false

export default {
  name: 'ScreenBigscreen',
  data () {
    return {
      // 通用
      // 各业务块年度独立多选（默认当前年；清空=该块全量不过滤年度）
      orderYear: [String(new Date().getFullYear())],
      deliveryYear: [String(new Date().getFullYear())],
      deliveryRateYear: [String(new Date().getFullYear())],
      orgYear: [String(new Date().getFullYear())],
      yearOptions: (() => { const y = new Date().getFullYear(); return [y, y - 1, y - 2, y - 3].map(String) })(),
      factoryCode: 'all',
      factoryList: [],
      updateTime: this.fmtNow(),
      refreshing: false,
      // KPI（真实数据由接口返回，无 mock 兜底）
      kpis: [],
      // 延迟天数
      delayData: { categories: [], incomplete: [], complete: [] },
      // 地图
      provinceData: [],
      mapTooltip: { show: false, name: '', total: 0, a: 0, b: 0, c: 0, d: 0 },
      mapDetail: { show: false, province: '', total: 0, a: 0, b: 0, c: 0, d: 0, avg: 0 },
      // 订单状态环形图
      orderStatus: { centerPct: '', items: [] },
      // 交货单执行环形图
      deliveryStatus: { centerPct: '', items: [] },
      // 交货完成率环形图
      deliveryRate: { centerPct: '', items: [] },
      // TOP10
      top10Mode: 'worst',
      // 月度筛选：默认当前月-1(YYYY-MM)，最近三年(36个月)可选；后端按 EVA_TYPE=3 + YEAR_MONTH 命中月度评价
      top10Month: (() => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0'); })(),
      top10MonthOptions: (() => { const arr = []; const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); for (let i = 0; i < 36; i++) { const y = d.getFullYear(); const m = String(d.getMonth() + 1).padStart(2, '0'); arr.push({ value: y + '-' + m, label: y + '-' + m }); d.setMonth(d.getMonth() - 1); } return arr; })(),
      top10Rows: [],
      // 组织下钻树
      orgTree: [],
      // SQL 弹窗
      SQL_DATABASE,
      sqlModalShow: false,
      currentSqlIdx: 0,
      sqlCopied: false,
      // ECharts 实例
      charts: {},
      // 全屏状态（嵌入右侧内容区 vs 覆盖式全屏）
      isFullscreen: false,
      // ResizeObserver 句柄（菜单折叠/展开时即时重算）
      resizeObserver: null
    }
  },
  computed: {
    flatOrgList () {
      const flat = this.flattenOrgTree(this.filteredOrgTree, 0, [], '', '')
      // 计算占比
      const topLevelTotal = this.filteredOrgTree.reduce((s, o) => s + (o.total || 0), 0)
      const maxRate = flat.length ? Math.max(...flat.map(o => o.rate || 0)) : 80
      return flat.map(o => ({
        ...o,
        maxRate,
        sharePct: topLevelTotal > 0 ? ((o.total / topLevelTotal) * 100).toFixed(1) : '0.0'
      }))
    },
    filteredOrgTree () {
      if (this.factoryCode === 'all') return this.orgTree
      // 兼容后端 OrgNode 字段命名（factory / factoryCode），避免字段对应错位致下钻表"暂无数据"
      return this.orgTree.filter(o => String(o.factory || o.factoryCode) === String(this.factoryCode))
    },
    currentSqlItem () {
      return this.SQL_DATABASE[this.currentSqlIdx] || { seq: '', name: '', table: '', sql: '' }
    },
    highlightedSql () {
      return this.highlightSql(this.formatSql(this.currentSqlItem.sql || ''))
    }
  },
  mounted () {
    // 嵌入态 .screen-bigscreen 为 absolute inset:0，需父级 el-card__body 作为定位上下文
    // （默认 static 会使 absolute 脱离到视口，变成覆盖式）。临时注入 relative，销毁时还原。
    const parent = this.$el && this.$el.parentElement
    if (parent) {
      this._prevParentPosition = parent.style.position || ''
      const pos = parent.style.position
      if (pos !== 'relative' && pos !== 'absolute' && pos !== 'fixed') {
        parent.style.position = 'relative'
      }
    }
    if (!mapRegistered) {
      this.$echarts.registerMap('china', chinaJson)
      mapRegistered = true
    }
    this.fitDashboard()
    this.$nextTick(() => this.fitDashboard())
    window.addEventListener('resize', this.onResize)
    if (screenfull.isEnabled) {
      this.fullscreenHandler = () => {
        // 浏览器原生全屏进入/退出时同步状态并重算（容器尺寸已变）
        this.isFullscreen = screenfull.isFullscreen
        this.$nextTick(() => this.fitDashboard())
      }
      screenfull.on && screenfull.on('change', this.fullscreenHandler)
    }
    // 监听父级 el-card__body 尺寸变化（左侧菜单折叠/展开不触发 window resize）；
    // 本元素 absolute 不撑开父级，故不会与 fitDashboard 形成正反馈
    if (parent && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        if (!this.isFullscreen) this.fitDashboard()
      })
      this.resizeObserver.observe(parent)
    }
    this.initAllCharts()
    this.loadAll()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    if (this.resizeObserver) { try { this.resizeObserver.disconnect() } catch (e) {} this.resizeObserver = null }
    if (screenfull.isEnabled && screenfull.off && this.fullscreenHandler) {
      try { screenfull.off('change', this.fullscreenHandler) } catch (e) {}
    }
    // 还原父级 el-card__body 的 position（mounted 临时注入的 relative）
    const parent = this.$el && this.$el.parentElement
    if (parent && this._prevParentPosition != null) {
      parent.style.position = this._prevParentPosition
    }
    Object.values(this.charts).forEach(c => { try { c && c.dispose() } catch (e) {} })
    this.charts = {}
  },
  methods: {
    /* ===== 自适应缩放 =====
       嵌入态：本元素 absolute inset:0 填满父级 el-card__body，直接读自身 clientWidth/
         clientHeight（稳定，因 absolute 不撑开父级）。按宽度铺满左右（scale=cw/1920），
         scale-wrap 高度撑开为真实缩放高度，本元素 overflow-y:auto 上下滚动查看完整内容。
       全屏态：尺寸取视窗，用 min(宽比,高比) 完整显示居中，.scale-wrap.is-fullscreen fixed 已铺满。 */
    fitDashboard () {
      const dash = this.$refs.dashboard
      if (!dash) return
      const DESIGN_W = 1920, DESIGN_H = 1080
      let cw, ch
      if (this.isFullscreen) {
        cw = document.documentElement.clientWidth || window.innerWidth
        ch = document.documentElement.clientHeight || window.innerHeight
      } else {
        // 嵌入态：本元素已 absolute inset:0 填满父级 el-card__body，直接读自身尺寸
        // （稳定：fitDashboard 不改变本元素尺寸，切断与 ResizeObserver 的正反馈）
        const el = this.$el
        cw = el ? el.clientWidth : (document.documentElement.clientWidth || window.innerWidth)
        ch = el ? el.clientHeight : (document.documentElement.clientHeight || window.innerHeight)
      }
      // 嵌入态按宽度铺满左右（上下可滚动），全屏态完整显示居中
      const scale = this.isFullscreen ? Math.min(cw / DESIGN_W, ch / DESIGN_H) : cw / DESIGN_W
      const scaledW = DESIGN_W * scale
      const scaledH = DESIGN_H * scale
      // 嵌入态把 scale-wrap 高度撑到真实缩放高度，供本元素 overflow-y:auto 滚动
      const wrap = this.$el && this.$el.querySelector('.scale-wrap')
      if (wrap) {
        if (this.isFullscreen) {
          wrap.style.height = ''
        } else {
          wrap.style.height = scaledH + 'px'
        }
      }
      dash.style.transform = `scale(${scale})`
      dash.style.marginLeft = `${(cw - scaledW) / 2}px`
      // 嵌入态顶对齐（滚动从顶部开始）；全屏态垂直居中
      dash.style.marginTop = this.isFullscreen ? `${(ch - scaledH) / 2}px` : '0px'
    },
    onResize () {
      this.fitDashboard()
      Object.values(this.charts).forEach(c => { try { c && c.resize() } catch (e) {} })
    },
    toggleFullscreen () {
      // 优先浏览器原生全屏（作用于 document.documentElement，ESC 退出，change 事件回写 isFullscreen）
      if (screenfull.isEnabled) {
        screenfull.toggle()
        return
      }
      // 不可用（iframe 等）退化为 CSS 伪全屏：is-fullscreen 类让根 fixed 覆盖 Layout
      this.isFullscreen = !this.isFullscreen
      this.$nextTick(() => this.fitDashboard())
    },
    fmt (v) {
      return Number(v || 0).toLocaleString()
    },
    fmtNow () {
      const d = new Date()
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },
    pct (n, total) {
      return total > 0 ? Math.round(n * 100 / total) : 0
    },

    /* ===== 数据加载 ===== */
    buildParams () {
      // 通用基础参数；子公司下拉切换时把 orgCode 反查为 sys_org.id 传 subcompanyId，全页按子公司过滤
      const p = { top10Mode: this.top10Mode }
      if (this.factoryCode && this.factoryCode !== 'all') {
        const sub = this.factoryList.find(f => f.orgCode === this.factoryCode)
        if (sub && sub.id != null) {
          p.subcompanyId = String(sub.id)
        } else {
          // 反查失败（子公司列表未加载或 getSubCompanyList 接口静默失败）：避免静默退化为全量数据
          console.warn('[大屏] 未匹配到子公司 id，factoryCode=', this.factoryCode, 'factoryList=', this.factoryList)
        }
      }
      return p
    },
    async loadAll () {
      // 工厂下拉（非关键，失败仅留"全部工厂"）——先 await 保证 buildParams 反查 subcompanyId 前 factoryList 已就绪，
      // 避免 onOrgSwitch 切子公司时 factoryList 尚未刷新或接口静默失败导致不传 subcompanyId 退化为全量数据
      await this.getFactoryListSafe()
      // 6 块各自独立加载；任一失败仅汇总提示，对应区块留空（不回退 mock）
      const loaders = [
        { name: 'KPI/延迟', fn: () => this.loadKpiDelay(true) },
        { name: '采购组织下钻', fn: () => this.loadOrgDrill(true) },
        { name: '订单完成率', fn: () => this.loadOrderStatus(true) },
        { name: '交货单执行', fn: () => this.loadDeliveryStatus(true) },
        { name: '交货完成率', fn: () => this.loadDeliveryRate(true) },
        { name: '供应商地图/TOP10', fn: () => this.loadSupplier(true) }
      ]
      const results = await Promise.allSettled(loaders.map(l => l.fn()))
      const failed = []
      results.forEach((r, i) => { if (r.status === 'rejected') failed.push(loaders[i].name) })
      if (failed.length && this.$message) {
        this.$message.error('大屏数据加载失败：' + failed.join('、') + '（接口异常或未部署）')
      }
      this.updateTime = this.fmtNow()
      this.$nextTick(() => this.initAllCharts())
    },
    async getFactoryListSafe () {
      try {
        const res = await getSubCompanyList()
        if (res && res.body && Array.isArray(res.body)) {
          this.factoryList = res.body.map(f => ({ id: f.id, orgCode: f.orgCode, orgName: f.orgName }))
        }
      } catch (e) { /* 子公司下拉非关键，失败仅留"全部子公司" */ }
    },
    /** KPI 4 项 + 延迟天数分布（全量，不传 years） */
    async loadKpiDelay (silent) {
      try {
        const res = await getKpi(this.buildParams())
        const b = res && res.body
        if (b) {
          this.kpis = Array.isArray(b.kpis) ? b.kpis.map((k, i) => ({ ...k, icon: KPI_ICONS[i] || KPI_ICONS[0] })) : []
          if (Array.isArray(b.delayRows)) {
            this.delayData = {
              categories: b.delayRows.map(r => r.label),
              incomplete: b.delayRows.map(r => r.undone),
              complete: b.delayRows.map(r => r.done)
            }
          }
        }
        this.$nextTick(() => this.initDelay())
      } catch (e) {
        if (!silent) this.$message && this.$message.error('KPI/延迟数据加载失败')
        throw e
      }
    },
    /** 采购组织下钻（years 多选，空=全量） */
    async loadOrgDrill (silent) {
      try {
        const res = await getOrgDrill({ ...this.buildParams(), years: this.orgYear.join(',') })
        const b = res && res.body
        if (b && Array.isArray(b.orgRows)) this.orgTree = b.orgRows
      } catch (e) {
        if (!silent) this.$message && this.$message.error('采购组织下钻加载失败')
        throw e
      }
    },
    /** 订单完成率（years 多选，按 order_tbl.BEDAT） */
    async loadOrderStatus (silent) {
      try {
        const res = await getOrderStatus({ ...this.buildParams(), years: this.orderYear.join(',') })
        const b = res && res.body
        if (b) this.orderStatus = b
        this.$nextTick(() => this.initOrderDonut())
      } catch (e) {
        if (!silent) this.$message && this.$message.error('订单完成率加载失败')
        throw e
      }
    },
    /** 交货单执行（years 多选，按 delivery.CREATE_TIME） */
    async loadDeliveryStatus (silent) {
      try {
        const res = await getDeliveryStatus({ ...this.buildParams(), years: this.deliveryYear.join(',') })
        const b = res && res.body
        if (b) this.deliveryStatus = b
        this.$nextTick(() => this.initDeliveryDonut())
      } catch (e) {
        if (!silent) this.$message && this.$message.error('交货单执行加载失败')
        throw e
      }
    },
    /** 交货完成率周期（years 多选，按 delivery.CREATE_TIME） */
    async loadDeliveryRate (silent) {
      try {
        const res = await getDeliveryRate({ ...this.buildParams(), years: this.deliveryRateYear.join(',') })
        const b = res && res.body
        if (b) this.deliveryRate = b
        this.$nextTick(() => this.initDeliveryRate())
      } catch (e) {
        if (!silent) this.$message && this.$message.error('交货完成率加载失败')
        throw e
      }
    },
    /** 供应商地图 + TOP10（无年度参数；TOP10 取最新年度 MAX(EVA_YEAR)） */
    async loadSupplier (silent) {
      try {
        const res = await getSupplierMap({ ...this.buildParams(), yearMonth: this.top10Month })
        const b = res && res.body
        if (b) {
          // 后端兜底回退：actualMonth 为后端实际使用的月份，同步下拉选中（程序设值不触发 @change）
          if (b.actualMonth) this.top10Month = b.actualMonth
          this.provinceData = Array.isArray(b.mapRegions) ? b.mapRegions : []
          this.top10Rows = Array.isArray(b.ranking)
            ? b.ranking.map(r => ({
              venderCode: r.venderCode || r.supplierCode,
              factory: r.factory || '',
              brand: r.brand || '',
              grade: (r.grade || r.classType || '').toString().toUpperCase(),
              score: r.score != null ? String(r.score) : ''
            }))
            : []
        }
        this.$nextTick(() => this.initMap())
      } catch (e) {
        if (!silent) this.$message && this.$message.error('供应商地图/TOP10加载失败')
        throw e
      }
    },

    /* ===== ECharts 初始化 ===== */
    initAllCharts () {
      this.initDelay()
      this.initMap()
      this.initOrderDonut()
      this.initDeliveryDonut()
      this.initDeliveryRate()
    },
    getChart (ref, key) {
      const el = this.$refs[ref]
      if (!el || el.clientWidth === 0) return null
      if (this.charts[key]) { try { this.charts[key].dispose() } catch (e) {} }
      this.charts[key] = this.$echarts.init(el)
      return this.charts[key]
    },
    initDelay () {
      const chart = this.getChart('delayChart', 'delay')
      if (!chart) return
      const { categories, incomplete, complete } = this.delayData
      const maxAbs = Math.max(0, ...incomplete, ...complete)
      // 兜底最小 200：无数据时 xMax=0 会使 xAxis min=max=0 范围坍缩，0 轴(markLine)贴左；保底 200 让 [-200,200] 0 轴居中
      const xMax = Math.max(200, Math.ceil(maxAbs / 200) * 200)
      chart.setOption({
        tooltip: { ...baseTooltip, trigger: 'axis', axisPointer: { type: 'shadow' },
          formatter: (params) => {
            const idx = params[0].dataIndex
            return `${categories[idx]}<br/>` +
              `<span style="color:#fb923c">●</span> 未完成：${incomplete[idx]} 单<br/>` +
              `<span style="color:#60a5fa">●</span> 已完成：${complete[idx]} 单`
          }
        },
        legend: {
          data: [
            { name: '未完成', icon: 'roundRect', textStyle: { color: '#fb923c', fontSize: 13, fontWeight: 600 } },
            { name: '已完成', icon: 'roundRect', textStyle: { color: '#60a5fa', fontSize: 13, fontWeight: 600 } }
          ],
          itemWidth: 14, itemHeight: 10, itemGap: 24, left: 60, top: 2
        },
        grid: { left: 60, right: 50, top: 32, bottom: 24, containLabel: false },
        xAxis: {
          type: 'value', min: -xMax, max: xMax, interval: xMax / 4,
          axisLine: { show: false }, axisTick: { show: false },
          splitLine: { lineStyle: { color: 'rgba(76,200,255,0.1)' } },
          axisLabel: { color: TEXT_MUTED, fontSize: 11, formatter: (v) => Math.abs(v).toLocaleString(), margin: 8 }
        },
        yAxis: {
          type: 'category', data: categories, inverse: true,
          axisLine: { show: false }, axisTick: { show: false },
          axisLabel: { color: TEXT_SECONDARY, fontSize: 12 }
        },
        series: [
          { name: '未完成', type: 'bar', stack: 'butterfly', data: incomplete.map(v => -v),
            itemStyle: { color: { type: 'linear', x: 1, y: 0, x2: 0, y2: 0, colorStops: [{ offset: 0, color: '#ea580c' }, { offset: 1, color: '#fb923c' }] }, borderRadius: [4, 0, 0, 4], shadowBlur: 8, shadowColor: 'rgba(251,146,60,0.5)' },
            barWidth: 14,
            label: { show: true, position: 'inside', color: '#fff', fontSize: 12, fontWeight: 700, fontFamily: 'DIN', formatter: (p) => incomplete[p.dataIndex] ? incomplete[p.dataIndex].toLocaleString() : '', textBorderColor: 'rgba(0,0,0,0.45)', textBorderWidth: 2 },
            z: 2 },
          { name: '已完成', type: 'bar', stack: 'butterfly', data: complete,
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 1, y2: 0, colorStops: [{ offset: 0, color: '#3b82f6' }, { offset: 1, color: '#60a5fa' }] }, borderRadius: [0, 4, 4, 0], shadowBlur: 8, shadowColor: 'rgba(96,165,250,0.5)' },
            barWidth: 14,
            label: { show: true, position: 'right', color: '#60a5fa', fontSize: 12, fontWeight: 700, fontFamily: 'DIN', formatter: (p) => complete[p.dataIndex] ? complete[p.dataIndex].toLocaleString() : '', distance: 6 },
            z: 2 },
          { name: '_center', type: 'line', data: categories.map(() => 0), symbol: 'none',
            lineStyle: { color: 'rgba(76,200,255,0.6)', width: 1 },
            markLine: { symbol: 'none', silent: true, animation: false, lineStyle: { color: '#4CC8FF', width: 2 }, label: { show: true, position: 'end', color: '#4CC8FF', fontSize: 11, fontWeight: 700, formatter: '0' }, data: [{ xAxis: 0 }] },
            z: 3 }
        ]
      })
    },
    initMap () {
      const chart = this.getChart('mapChart', 'map')
      if (!chart) return
      const data = this.provinceData.length ? this.provinceData : []
      const maxVal = data.length ? Math.max.apply(null, data.map(d => d.value || 0)) : 1
      chart.setOption({
        tooltip: { show: false },
        visualMap: { type: 'continuous', min: 0, max: maxVal || 1, calculable: false, inRange: { color: ['rgba(76,200,255,0.08)', 'rgba(76,200,255,0.45)', 'rgba(76,200,255,0.85)'] }, show: false },
        geo: { map: 'china', roam: false, zoom: 1.2, aspectScale: 0.85, layoutCenter: ['50%', '62%'], layoutSize: '108%',
          label: { show: false },
          itemStyle: { areaColor: 'rgba(76,200,255,0.05)', borderColor: 'rgba(76,200,255,0.4)', borderWidth: 1 },
          emphasis: { disabled: false, itemStyle: { areaColor: 'rgba(6,182,212,0.35)' }, label: { show: true, color: '#fff', fontSize: 12 } }
        },
        series: [{ type: 'map', map: 'china', geoIndex: 0, data: data.map(d => ({ name: d.name, value: d.value, grades: d.grades })) }]
      })
      chart.off('mouseover')
      chart.off('mouseout')
      chart.off('click')
      chart.on('mouseover', (params) => {
        if (!params || !params.name) return
        const p = data.find(x => x.name === params.name)
        if (p) this.showMapTooltip(p)
      })
      chart.on('mouseout', () => { this.mapTooltip.show = false })
      chart.on('click', (params) => {
        if (!params || !params.name) return
        const p = data.find(x => x.name === params.name)
        if (p) this.showMapDetail(p)
      })
    },
    showMapTooltip (p) {
      const g = p.grades || {}
      this.mapTooltip = { show: true, name: p.name, total: p.value, a: g.A || 0, b: g.B || 0, c: g.C || 0, d: g.D || 0 }
    },
    showMapDetail (p) {
      const g = p.grades || {}
      const total = (g.A || 0) + (g.B || 0) + (g.C || 0) + (g.D || 0)
      this.mapDetail = { show: true, province: p.name, total: p.value, a: g.A || 0, b: g.B || 0, c: g.C || 0, d: g.D || 0, avg: '—' }
    },
    initOrderDonut () {
      const chart = this.getChart('orderDonut', 'orderDonut')
      if (!chart) return
      chart.setOption({
        tooltip: { ...baseTooltip, appendToBody: true, trigger: 'item', formatter: (p) => {
          const it = this.orderStatus.items[p.dataIndex] || {}
          return `<div style="font-weight:700;margin-bottom:2px">${it.name || ''}</div>` +
            `数量：${it.value || 0}<br/>占比：${it.pct || 0}%<br/>订单完成率：${this.orderStatus.centerPct || 0}%`
        } },
        series: [{ type: 'pie', radius: ['60%', '78%'], center: ['50%', '50%'], avoidLabelOverlap: false, startAngle: 90, label: { show: false }, labelLine: { show: false },
          data: this.orderStatus.items.map(it => ({ name: it.name, value: Number(String(it.value).replace(/,/g, '')), itemStyle: { color: it.color } })),
          itemStyle: { borderColor: 'rgba(13,31,58,0.9)', borderWidth: 2 } }]
      })
    },
    initDeliveryDonut () {
      const chart = this.getChart('deliveryDonut', 'deliveryDonut')
      if (!chart) return
      chart.setOption({
        tooltip: { ...baseTooltip, appendToBody: true, trigger: 'item', formatter: (p) => {
          const it = this.deliveryStatus.items[p.dataIndex] || {}
          return `<div style="font-weight:700;margin-bottom:2px">${it.name || ''}</div>` +
            `数量：${it.value || 0}<br/>占比：${it.pct || 0}%<br/>交货单完成率：${this.deliveryStatus.centerPct || 0}%`
        } },
        series: [{ type: 'pie', radius: ['60%', '78%'], center: ['50%', '50%'], avoidLabelOverlap: false, startAngle: 90, label: { show: false }, labelLine: { show: false },
          data: this.deliveryStatus.items.map(it => ({ name: it.name, value: Number(String(it.value).replace(/,/g, '')), itemStyle: { color: it.color } })),
          itemStyle: { borderColor: 'rgba(13,31,58,0.9)', borderWidth: 2 } }]
      })
    },
    initDeliveryRate () {
      const chart = this.getChart('deliveryRateDonut', 'deliveryRate')
      if (!chart) return
      chart.setOption({
        tooltip: { ...baseTooltip, appendToBody: true, trigger: 'item', formatter: (p) => {
          const it = this.deliveryRate.items[p.dataIndex] || {}
          return `<div style="font-weight:700;margin-bottom:2px">${it.name || ''}</div>` +
            `数量：${it.value || 0}<br/>占比：${it.pct || 0}%<br/>7天内完成：${this.deliveryRate.centerPct || 0}%`
        } },
        series: [{ type: 'pie', radius: ['60%', '78%'], center: ['50%', '50%'], avoidLabelOverlap: false, startAngle: 90, label: { show: false }, labelLine: { show: false },
          data: this.deliveryRate.items.map(it => ({ name: it.name, value: Number(String(it.value).replace(/,/g, '')), itemStyle: { color: it.color } })),
          itemStyle: { borderColor: 'rgba(13,31,58,0.9)', borderWidth: 2 } }]
      })
    },

    /* ===== 组织下钻树扁平化 ===== */
    flattenOrgTree (nodes, level, acc, parentFactory) {
      for (const node of nodes) {
        const hasChildren = Array.isArray(node.children) && node.children.length > 0
        const isLeaf = !!node.isLeaf
        acc.push({
          id: node.id, name: node.name, factory: node.factory || parentFactory,
          total: node.total, inProgress: node.inProgress, completed: node.completed,
          rate: node.rate, level, hasChildren, isLeaf, expanded: !!node.expanded
        })
        if (hasChildren && node.expanded) {
          this.flattenOrgTree(node.children, level + 1, acc, node.factory || parentFactory)
        }
      }
      return acc
    },
    findOrgNode (nodes, id) {
      for (const node of nodes) {
        if (node.id === id) return node
        if (node.children) {
          const found = this.findOrgNode(node.children, id)
          if (found) return found
        }
      }
      return null
    },
    toggleOrgNode (id) {
      const node = this.findOrgNode(this.orgTree, id)
      if (node) {
        node.expanded = !node.expanded
      }
    },
    orgBarWidth (o) {
      const maxRate = o.maxRate || 80
      return Math.max(0, Math.min(100, ((o.rate - 70) / Math.max(1, (maxRate - 70))) * 100))
    },

    /* ===== 交互 ===== */
    onOrgSwitch () {
      // 切换子公司：全页所有数据按所选子公司重新加载（各 loader 经 buildParams 带 subcompanyId）
      this.loadAll()
    },
    async onRefresh () {
      this.refreshing = true
      await this.loadAll()
      this.refreshing = false
    },
    onTop10MonthChange () {
      // 切换月度按所选 YYYY-MM 重新拉取 TOP10（与 top10Mode 叠加）
      this.loadSupplier().catch(() => {})
    },
    onTop10Toggle (mode) {
      this.top10Mode = mode
      // 真去后端按 best(DESC)/worst(ASC) 重新拉取 TOP10，而非本地倒排（后端取真正的前 10）
      this.loadSupplier().catch(() => {})
    },
    /* 跳转到供应商绩效查询页，并预填当前评价年度 */
    goSupplierEva () {
      this.$router.push({ path: '/supplier-supplierEvaQuery', query: { year1: this.yearOptions[0] } })
    },
    /* 年度多选切换：仅刷新对应块，互不影响（失败由各 loader 自身提示） */
    onOrderYearChange () {
      this.loadOrderStatus().catch(() => {})
    },
    onDeliveryYearChange () {
      this.loadDeliveryStatus().catch(() => {})
    },
    onDeliveryRateYearChange () {
      this.loadDeliveryRate().catch(() => {})
    },
    onOrgYearChange () {
      this.loadOrgDrill().catch(() => {})
    },
    /* 导出采购组织明细（任务级，调后端 exportDetail，按当前子公司+年度过滤） */
    async onExportOrg () {
      try {
        const res = await exportDetail({ ...this.buildParams(), years: this.orgYear.join(',') })
        const list = res && res.body
        if (!Array.isArray(list) || list.length === 0) {
          this.$message && this.$message.warning('暂无数据可导出')
          return
        }
        const cols = [
          ['子公司', 'subcompany_name'],
          ['采购组织', 'purchase_org_name', 'purchase_org_code'],
          ['项目编码', 'project_code'],
          ['任务编码', 'task_code'],
          ['任务名称', 'task_name'],
          ['车型', 'car_type'],
          ['技术通知单号', 'technical_code'],
          ['任务类型', 'task_type'],
          ['报价单类型', 'rfq_type'],
          ['招标类型', 'source_type'],
          ['项目管理员', 'project_manager_name'],
          ['项目工程师', 'project_engineer'],
          ['采购工程师', 'purchase_engineer'],
          ['技术负责人', 'tech_responsor'],
          ['质量负责人', 'quality_responsor'],
          ['提交人', 'submitor'],
          ['任务状态', 'status_name'],
          ['询价状态', 'ask_price_status'],
          ['是否办结', 'done_label'],
          ['轮次', 'times'],
          ['延期次数', 'delay_times'],
          ['询价编码', 'rfq_code'],
          ['费用单号', 'fee_code'],
          ['是否作废', 'cancel_label'],
          ['创建任务时间', 'create_task_time'],
          ['任务分配时间', 'task_allocation_time'],
          ['询价创建时间', 'rfq_create_time'],
          ['本轮截止时间', 'rfq_finish_time'],
          ['定点通过时间', 'fixed_point_approve_time'],
          ['延迟天数', 'delay_days'],
          ['退回理由', 'reject_reason'],
          ['备注', 'remark']
        ]
        const esc = (v) => {
          const s = String(v == null ? '' : v)
          return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
        }
        const pick = (row, fields) => {
          for (let i = 1; i < fields.length; i++) {
            const v = row[fields[i]]
            if (v != null && v !== '') return v
          }
          return ''
        }
        const header = cols.map(c => c[0]).join(',')
        const lines = list.map(row => cols.map(c => pick(row, c)).map(esc).join(','))
        // 开头加 BOM 防止 Excel 打开中文乱码
        const csv = '﻿' + header + '\n' + lines.join('\n')
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `采购组织明细_${this.orgYear.join('-') || '全部'}.csv`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message && this.$message.error('导出失败')
        throw e
      }
    },

    /* ===== SQL 弹窗 ===== */
    openSqlModal () {
      this.sqlModalShow = true
    },
    closeSqlModal () {
      this.sqlModalShow = false
    },
    shortTable (rawTable) {
      if (!rawTable) return ''
      const tables = rawTable.split(/\s+(?:LEFT|INNER|RIGHT|OUTER)?\s*JOIN\s+|,|\/|\s-\s/i).map(s => s.trim()).filter(Boolean)
      return tables.length > 1 ? `${tables[0]} +${tables.length - 1}` : tables[0]
    },
    handleCopySql () {
      const sql = this.currentSqlItem.sql || ''
      const onOk = () => {
        this.sqlCopied = true
        setTimeout(() => { this.sqlCopied = false }, 1800)
      }
      const fallback = (txt) => {
        const ta = document.createElement('textarea')
        ta.value = txt; ta.style.position = 'fixed'; ta.style.opacity = '0'
        document.body.appendChild(ta); ta.select()
        try { document.execCommand('copy') } catch (e) {}
        document.body.removeChild(ta)
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(sql).then(onOk).catch(() => { fallback(sql); onOk() })
      } else { fallback(sql); onOk() }
    },
    formatSql (rawSql) {
      if (!rawSql) return ''
      const strs = []
      let s = rawSql.replace(/'([^']*)'/g, function (_, inner) { strs.push("'" + inner + "'"); return '§STR' + (strs.length - 1) + '§' })
      s = s.replace(/\s+/g, ' ').trim()
      const newlineKw = ['FROM', 'WHERE', 'GROUP BY', 'ORDER BY', 'HAVING', 'LIMIT', 'LEFT JOIN', 'RIGHT JOIN', 'INNER JOIN', 'JOIN', 'UNION ALL', 'UNION']
      newlineKw.forEach((kw) => {
        const re = new RegExp('\\s+(' + kw.replace(/ /g, '\\s+') + ')\\b', 'gi')
        s = s.replace(re, '\n$1')
      })
      s = s.replace(/^SELECT\s+/i, 'SELECT\n  ')
      s = s.replace(/,\s*(?=(?:[A-Za-z_`"\[]|COUNT|SUM|AVG|MAX|MIN|ROUND|CASE|ROW_NUMBER|DATEDIFF|NOW|IF)\b)/g, ',\n  ')
      s = s.replace(/\s+CASE\s+/gi, '\n  CASE ')
      s = s.replace(/\s+WHEN\s+/gi, '\n    WHEN ')
      s = s.replace(/\s+THEN\s+/gi, ' THEN ')
      s = s.replace(/\s+ELSE\s+/gi, '\n    ELSE ')
      s = s.replace(/\s+END\b/gi, '\n  END')
      s = s.replace(/\s+AND\s+/gi, '\n    AND ')
      s = s.replace(/\s+OR\s+/gi, '\n    OR ')
      s = s.replace(/\s+--/g, '\n  --')
      s = s.replace(/§STR(\d+)§/g, function (_, i) { return strs[+i] })
      return s.trim()
    },
    highlightSql (sql) {
      if (!sql) return ''
      const strs = []
      let s = sql.replace(/'([^']*)'/g, function (_, inner) { strs.push("'" + inner + "'"); return '§S_' + (strs.length - 1) + '_§' })
      const coms = []
      s = s.replace(/--[^\n]*/g, function (m) { coms.push(m); return '§C_' + (coms.length - 1) + '_§' })
      s = String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      const SQL_KW = ['SELECT','FROM','WHERE','GROUP BY','ORDER BY','HAVING','LIMIT','AS','AND','OR','NOT','NULL','IS','IN','LIKE','BETWEEN','EXISTS','CASE','WHEN','THEN','ELSE','END','LEFT','RIGHT','INNER','OUTER','FULL','CROSS','ON','JOIN','USING','UNION','ALL','INTERSECT','EXCEPT','DISTINCT','ASC','DESC','OVER','PARTITION BY','WITH','DELETE_FLAG']
      const SQL_FN = ['COUNT','SUM','AVG','MAX','MIN','ROUND','DATEDIFF','NOW','IF','IFNULL','COALESCE','CAST','CONVERT','SUBSTRING','LENGTH','TRIM','UPPER','LOWER','DATE_ADD','DATE_SUB','DATE_FORMAT','YEAR','MONTH','DAY','ROW_NUMBER','RANK','DENSE_RANK','NTILE','LAG','LEAD','GREATEST','LEAST','ABS','CEIL','FLOOR','CONCAT']
      const sortedKw = SQL_KW.slice().sort((a, b) => b.length - a.length)
      s = s.replace(new RegExp('\\b(' + sortedKw.join('|') + ')\\b', 'g'), '<span class="sql-kw">$1</span>')
      const sortedFn = SQL_FN.slice().sort((a, b) => b.length - a.length)
      s = s.replace(new RegExp('\\b(' + sortedFn.join('|') + ')\\s*\\(', 'g'), '<span class="sql-fn">$1</span>(')
      s = s.replace(/\b(\d+(?:\.\d+)?)\b/g, '<span class="sql-num">$1</span>')
      s = s.replace(/§C_(\d+)_§/g, function (_, i) { return '<span class="sql-com">' + String(coms[+i]).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>' })
      s = s.replace(/§S_(\d+)_§/g, function (_, i) { return '<span class="sql-str">' + strs[+i].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>' })
      return s
    }
  }
}
</script>

<style lang="scss">
/* 非 scoped：所有选择器均嵌套在 .screen-bigscreen 根下，不会污染主应用；
   且 position:fixed 覆盖式大屏 + ECharts 动态 DOM 不受 scoped data-v 属性匹配约束。 */
@import './dashboard.scss';
</style>
